<div class="container-fluid">
    <div fxFlexFill FxLayout="column" class="card">
      <div class="card-body" fxLayoutAlign="center center">
        <h5 style="text-align: center;">
            The organization associated to your account is not currently managed within PEBB My Account. Please contact your Payroll and Benefits office.
        </h5>
      </div>
    </div>
  </div>
  